import { Dropdown, Menu, TableColumnsType, Tooltip } from "antd";

import { IIndustry, ISector } from "@types";
import { permissions } from "@router";
import { checkPermission } from "@utils";
import { ReactComponent as MenuIcon } from "@assets/images/vertical-dots.svg";
import { GoPencil } from "react-icons/go";
import { BsTrash3 } from "react-icons/bs";

export const getColumns = ({
  handleActionDropdown,
}: {
  handleActionDropdown: ({
    item,
    key,
    domEvent,
  }: {
    key: string;
    domEvent:
      | React.MouseEvent<HTMLElement, MouseEvent>
      | React.KeyboardEvent<HTMLElement>;
    item: ISector;
  }) => void;
}) => {
  const columns: TableColumnsType<ISector> = [
    {
      title: "Sector",
      dataIndex: "name",
      key: "sector",
      width: 200,
      render: (name: string) => <div className="text-wrap">{name}</div>,
    },
    {
      title: "Industry",
      dataIndex: "industries",
      key: "industry",
      width: `calc(100% - 460px)`,
      render: (industries: IIndustry[]) => {
        if (!industries?.length) return null;

        const names = industries.map((industry: IIndustry) => industry.name);

        const visibleCount = 5;
        const remaining = names.length - visibleCount;

        return (
          <Tooltip title={names.join(", ")}>
            <span>
              {names.slice(0, visibleCount).join(", ")}
              {remaining > 0 && (
                <span className="text-blue-500 text-center text-xs font-semibold mx-2">
                  {" ... "}+{remaining}
                </span>
              )}
            </span>
          </Tooltip>
        );
      },
    },
    ...((!checkPermission([
      permissions.UPDATE_SECTOR,
      permissions.DELETE_SECTOR,
    ])
      ? []
      : [
          {
            title: "Actions",
            key: "action",
            width: 160,
            align: "center",
            render: (item: ISector) => (
              <div className="flex items-center gap-2">
                {checkPermission(permissions.UPDATE_SECTOR) && (
                  <div
                    onClick={e =>
                      handleActionDropdown({
                        item,
                        key: "1",
                        domEvent: e,
                      })
                    }
                    className="table__action__btn table__action__btn--client"
                  >
                    <GoPencil className="text-white mr-1 text-sm" /> Edit
                  </div>
                )}

                {checkPermission(permissions.DELETE_SECTOR) && (
                  <div
                    onClick={e =>
                      handleActionDropdown({
                        item,
                        key: "2",
                        domEvent: e,
                      })
                    }
                    className="table__action__btn table__action__btn--delete"
                  >
                    <BsTrash3 className="text-white textx mr-1" /> Delete
                  </div>
                )}
              </div>
            ),
          },
        ]) as any),
  ];

  return columns;
};
